module.exports = __webpack_public_path__ + "media/images/fastest_option-ecf46d73.svg";